// «Мои: просрочено · сегодня · на этой неделе» (030: T020; FR-033, FR-034; contracts/api.md,
// my.summary): счётчик у пункта меню «Мои задачи» и строка «Главной». Запрос — только у связанного
// с человеком (me.person): без связи сервер ответит ACC-008. Фоновый опрос раз в минуту
// с X-KP-Background — сеанс он не продлевает (FR-008б 001). Экран «Мои задачи» после ответа
// сбрасывает этот ключ (apiKey('my.summary')), и число обновляется сразу.
import { apiQuery } from '../api/client.ts';

export function mySummaryQuery() {
  return {
    ...apiQuery('my.summary', { background: true }),
    refetchInterval: 60_000,
    staleTime: 30_000,
  };
}
